module dg.files {

    class FileUploadController {

        private apiUrl: string;
        private flow: flowjs.IFlow;
        private flowFile: flowjs.IFlowFile;
        private maxBlockSize: number = 256 * 1024;
        private blockIds = new Array<string>();
        //private command: any;

        private isUploadComplete: boolean;

        public value: dg.domain.files.BlobFileInfo;
        public valueObj: dg.domain.files.BlobFileInfo;

        public formEditor: dg.objects.FormEditorController;
        public ngModel: ng.INgModelController;
        public uploadDeferred: ng.IDeferred<any>;
        public objectEditorController: dg.objects.ObjectEditorController;
        public errors: string[];
        public supportedMimeTypes: any;

        readonly NullValue: dg.domain.files.BlobFileInfo = {
            fileName: null,
            pattern: null,
            uploadUrl: null,
            maxSizeMb: null,
            supportedMimeTypes: null,
            domainType: "blob-file-info"
        };

        public constructor(
            private $q: ng.IQService,
            private $scope: ng.IScope,
            private $timeout: ng.ITimeoutService,
            private blobStorageService: dg.files.BlobStorageService,
            private actionService: dg.actions.ActionService) {

            this.valueObj = dgUtils.ObjectHelperService.mergeDeep(this.valueObj, this.NullValue);
        }

        $onInit() {
            this.formEditor.onPreExecute(this.beginUpload);
        }

        $onChanges(changes) {

            if (changes.value.currentValue) {
                this.valueObj = dgUtils.ObjectHelperService.mergeDeep(this.valueObj, changes.value.currentValue);

                //if (this.valueObj.supportedMimeTypes.length == 1 && this.valueObj.supportedMimeTypes[0] == "") {
                //    this.supportedMimeTypes = '*';
                //}
                //else {
                //    this.supportedMimeTypes = this.valueObj.supportedMimeTypes;
                //}

                //if (!changes.value.currentValue.fileName) {
                //    this.clearViewModel();
                //}
            }
            //else {
            //    this.clearViewModel();
            //}
        }

        public validate(flowFile: flowjs.IFlowFile) {
            this.errors = [];

            if (this.valueObj.pattern) {
                var regex = new RegExp(this.valueObj.pattern);
                if (!regex.test(flowFile.name)) {
                    this.errors.push(`Filename invalid`);
                    return false;
                }     
            }
            
            if (flowFile.size > this.valueObj.maxSizeMb * 1048576) {
                this.errors.push(`File size must be less than ${this.valueObj.maxSizeMb}MB`);
                return false;
            }

            ////HACK: Zip file on some machines have '' for mime type 
            //if (flowFile.file.type != '' && this.valueObj.supportedMimeTypes.indexOf(flowFile.file.type) == -1) {
            //    this.errors.push(`File format is not supported`);
            //    return false;
            //}
            return true;
        }

        public beginUpload = () => {
            this.uploadDeferred = this.$q.defer();
            if (this.flowFile) {
                this.blobStorageService.getBlobContainerAccessUrl()
                    .then(result => {

                        //TODO: probably we need another method that return the aggregateId as well
                        let formParams = this.actionService.getQueryParams(<any>this.objectEditorController.value);
                        formParams.aggregateId = (<any>this.objectEditorController.value).aggregateId;

                        let containerUrl = this.blobStorageService.replaceUrlPlaceholders(this.valueObj.uploadUrl, formParams);
                        this.apiUrl = this.blobStorageService.buildUrl(result.resourceUrl, containerUrl, result.token);

                        this.$timeout(() => {
                            if (this.flow.progress() > 0) {
                                this.flow.addFile(this.flowFile.file);

                            }
                            this.flow.upload();
                        });

                    }, this.uploadDeferred.reject);
            } else {
                this.uploadDeferred.resolve();
            }

            return this.uploadDeferred.promise;
        }

        public filesSubmitted = () => {
            if (this.errors.length < 1) {
                let opts = <any>this.flow.opts;
                opts["target"] = this.getApiUrl;
                this.flow.opts["headers"]['x-ms-blob-type'] = 'BlockBlob';
                this.flow.opts["allowDuplicateUploads"] = true;
                this.flowFile = this.flow.files[0];
                this.valueObj.fileName = this.flowFile.name;
                //let fileCommand = {
                //    fileName: this.flowFile.name
                //}

                //this.ngModel.$setViewValue(this.valueObj);
                //this.ngModel.$setViewValue(null);
                //this.value = null;

                this.ngModel.$setViewValue(this.valueObj);
            }
            else {
                this.valueObj.fileName = null;
                this.clearViewModel();
            }

        }

        public getApiUrl = () => {
            return this.blobStorageService.generateBlockBlobUrl(this.apiUrl, this.blockIds);
        }

        public blocksUploadComplete() {
            this.blobStorageService.commitBlockList(this.apiUrl, this.flowFile.file.type, this.blockIds)
                .then(() => {
                    this.blockIds = new Array<string>();
                    this.isUploadComplete = true;
                    this.uploadDeferred.resolve();
                }, this.uploadDeferred.reject);
        }


        private clearViewModel() {
            this.$timeout(() => {
                this.ngModel.$setViewValue(null);
                this.ngModel.$setPristine();
            });
        }
    }

    angular.module('dg.files')
        .component('fileUpload', {
            bindings: {
                value: '<ngModel',
                propMeta: '<'
            },
            require: {
                ngModel: 'ngModel',
                formEditor: '^^formEditor',
                objectEditorController: '^objectEditor'
            },
            controller: FileUploadController,
            templateUrl: '/digmo/src/files/file-upload.html'
        });
}   